/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HideEmptyRubricRowDescriptionSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('HIDE_EMPTY_RUBRIC_ROW_DESCRIPTION')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class HideEmptyRubricRowDescriptionSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HideEmptyRubricRowDescriptionSettingParser.decode(input).map(res => new HideEmptyRubricRowDescriptionSetting(res));
    }
    static unsafeDecode(input) {
        return HideEmptyRubricRowDescriptionSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HideEmptyRubricRowDescriptionSettingParser.encode(data);
    }
    static schema() {
        return HideEmptyRubricRowDescriptionSettingParser.schema();
    }
}
